import React from 'react';
import './Welcome.css';

const Welcome: React.FC = () => {
  return (
    <section className="welcome-section">
      <div className="container">
        <h2 className="welcome-title">Welcome to The Collective at Gateway</h2>
        <div className="welcome-content">
          <p className="welcome-text">
            The Collective at Gateway offers premium flexible office spaces
            designed to meet the needs of modern businesses. Our workspace
            solutions provide the perfect environment for productivity, collaboration,
            and growth.
          </p>
          <p className="welcome-text">
            Whether you're a startup, small business, or established company looking
            for flexible workspace options, we offer a range of solutions from
            dedicated desks to private offices with flexible leasing terms.
          </p>
          <div className="welcome-features-container">
            <ul className="welcome-features-column">
              <li>Short-term and long-term leasing options</li>
              <li>Fully furnished and move-in ready spaces</li>
            </ul>
            <ul className="welcome-features-column">
              <li>Professional business environment</li>
              <li>Prime location at 1810 Gateway Dr, 94404, San Mateo</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome; 